// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
  align-items: center;
  display: flex;
  height: 60px;
  justify-content: end;
  list-style-type: none;
  width: 100%;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.pagination li.page-item {
  border-radius: 5px;
  margin: 0 0.15rem;
  overflow: hidden;
}
.pagination li.page-item:hover a.page-link {
  background: #354e80;
  color: #fff;
}
.pagination li.page-item a.page-link {
  background: #fff;
  display: block;
  color: #0c0f12;
  height: 40px;
  width: 40px;
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: none;
}
.pagination li.page-item.disabled {
  opacity: 0.6;
  pointer-events: none;
}
.pagination li.page-item.active a.page-link {
  background: #354e80;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/common/dynamicPagination.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,iDAAA;AAFF;AAIE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAFJ;AAIM;EACE,mBAAA;EACA,WAnBM;AAiBd;AAKI;EACE,gBAAA;EACA,cAAA;EACA,cAxBgB;EAyBhB,YAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;AAHN;AAME;EACE,YAAA;EACA,oBAAA;AAJJ;AAOI;EACE,mBAAA;EACA,WA3CQ;AAsCd","sourcesContent":["$color_white: #fff;\r\n$color_black_for_txt: #0c0f12;\r\n\r\n.pagination {\r\n  align-items: center;\r\n  display: flex;\r\n  height: 60px;\r\n  justify-content: end;\r\n  list-style-type: none;\r\n  width: 100%;\r\n  font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n  li.page-item {\r\n    border-radius: 5px;\r\n    margin: 0 .15rem;\r\n    overflow: hidden;\r\n    &:hover {\r\n      a.page-link {\r\n        background: #354e80;\r\n        color: $color_white;\r\n      }\r\n    }\r\n    a.page-link {\r\n      background: #fff;\r\n      display: block;\r\n      color: $color_black_for_txt;\r\n      height: 40px;\r\n      width: 40px;\r\n      border-radius: .5rem;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      text-decoration: none;\r\n      border: none;\r\n    }\r\n  }\r\n  li.page-item.disabled {\r\n    opacity: .6;\r\n    pointer-events: none;\r\n  }\r\n  li.page-item.active {\r\n    a.page-link {\r\n      background: #354e80;\r\n      color: $color_white;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
